import request from '@/request'
import common from '@/common.js'

const state = {
	// ksh5gj71_login: {},
	kso7zj3m_titles: [
	],
	fxxx_detail: [],
	// 研究中心-详情数据
	ktwdcolq_detail: {
		// 基本信息
		organization: {},
		// 立项流程
		lxlc: [],
		// 合同签署要求
		ht: [],
		// 备案专业信息
		bazyxx: [],
		// 伦理成员
        llcy: {
            data: [],
            llcypdf:'',
        },
        // 伦理财务信息
        llcwxx: {},
        // 主协议流程
        xylc: {},
        // 主协议流程
        crcxylc: {},
		// 伦理审查清单及模板
		llsc: [],
		// 伦理会议
		hyjbxx: {},
		llhy: [],
		// 相关申办方
		sbf: [],
		// 相关研究者
		xhyjz: [],
		// 相关试验
		syfq: {
			// 全部
			all: {},
			// 进行中
			jxz: {},
			// 已暂停
			zt: {},
			// 已终止
			zz: {},
			// 已完成
			wc: {},
		},
		// 进行中的试验
		jxz_list: [],
		// 已完成的试验
		wc_list: [],
		// 费用支付
		fyzf: {},
		// 伦理基本信息
		


	},
	kso8qcpa_detail: {
		jbxx: {
			trial_id: '',
			trial_title: '',
			xgdjh: '',
			ywcym: '',
			protocol_id: '',
			lcsqslh: '',
			fazxbbh: '',
			disease: '',
			bbrq: '',
			tested_drug_classification: '',
			lhyy: '',
		}
	},
	ksr88u7r_detail: {
		company_info: {
			summary: '',
			address: '',
			employee: '',
			tel: '',
			official_website: '',
			stock_code: '',
			setup_time: '',
		},
		gsxx: {
		}
	},
	kt14069k_detail: {
		yjz_info: {},
		syfq: {
			all: {},
		},
		vbyjz: {},
		syz_list:[]
	},
	chictr_detail: {
		info: {
			zch: '',
			info: ''
		}
	},
	ksr88cro_detail: {
		company_info: {
			summary: '',
			address: '',
			employee: '',
			tel: '',
			official_website: '',
			stock_code: '',
			setup_time: '',
		},
		gsxx: {
		}
	},
	ksr88lab_detail: {
		company_info: {
			summary: '',
			address: '',
			employee: '',
			tel: '',
			official_website: '',
			stock_code: '',
			setup_time: '',
		},
		gsxx: {
		}
	},
	medicalguide_detail: {
		baseinfo: {
		},
		gsxx: {
		}
	},
	smo_detail: {
		baseinfo: {
		},
		gsxx: {
		}
	},
	supplier_detail: {
		baseinfo: {
		},
	},
	guideprinciple_detail: {
		baseinfo: {
		}
	},
	linchuangus_detail: {
		info: {
		},
		gycs:[],
		ssfz:[],
	},
	linchuangkr_detail: {
		info: {
		},
		detail: {
			Background: {}
		},
	},
	linchuangjp_detail: {
		info: {
		},
		detail: {
			基本情報: {
				'研究名称/Scientific Title（Acronym）':[]
			}
		},
    },
    linchuangau_detail: {
        info: {
        },
        titles: {
            'Public title': '',
        }
    },
    researcherrisk_detail: {
        
    },
	// 企业信息
	firm_detail: {

	},
}
const mutations = {
	// 标题 组件 push 进去
	kso7zj3m_titles(state, payload) {
		state.kso7zj3m_titles = payload;
	},
	fxxx_detail(state, payload) {
		state.fxxx_detail = payload;
	},
	ktwdcolq_detail(state, payload) {
		state.ktwdcolq_detail = payload;
	},
	kso8qcpa_detail(state, payload) {
		state.kso8qcpa_detail = payload;
	},
	ksr88u7r_detail(state, payload) {
		state.ksr88u7r_detail = payload;
	},
	kt14069k_detail(state, payload) {
		state.kt14069k_detail = payload;
	},
	chictr_detail(state, payload) {
		state.chictr_detail = payload;
	},
	linchuangus_detail(state, payload) {
		state.linchuangus_detail = payload;
	},
	linchuangkr_detail(state, payload) {
		state.linchuangkr_detail = payload;
	},
	linchuangjp_detail(state, payload) {
		state.linchuangjp_detail = payload;
    },
    linchuangau_detail(state, payload) {
        state.linchuangau_detail = payload;
    },
	ksr88cro_detail(state, payload) {
		state.ksr88cro_detail = payload;
	},
	ksr88lab_detail(state, payload) {
		state.ksr88lab_detail = payload;
	},
	medicalguide_detail(state, payload) {
		state.medicalguide_detail = payload;
	},
	smo_detail(state, payload) {
		state.smo_detail = payload;
	},
	supplier_detail(state, payload) {
		state.supplier_detail = payload;
	},
	guideprinciple_detail(state, payload) {
		state.guideprinciple_detail = payload;
    },
    researcherrisk_detail(state, payload) {
        state.researcherrisk_detail = payload;
    },
    firm_detail(state, payload) {
        state.firm_detail = payload;
    },
}
const actions = {
	// 研究中心-详情页数据
	async ktwdcolq_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/organization/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('ktwdcolq_detail', res.data);
		}
	},
	// 申办方、CRO、LAB、SMO详情-风险信息
	async fxxx_detail({ commit }, path) {
		let res = await request.post('/Ajaxauth/getFxxx', {
			path
		})
		if (res.state == 0) {
			commit('fxxx_detail', res.data);
		}
	},
	// 试验-详情页数据
	async kso8qcpa_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/trials/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('kso8qcpa_detail', res.data);
		}
	},
	// 申办方-详情页数据
	async ksr88u7r_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/sponsor/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('ksr88u7r_detail', res.data);
		}
	},
	// 研究者-详情页数据
	async kt14069k_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/investigator/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('kt14069k_detail', res.data);
		}
	},
	// 试验注册-详情页数据
	async chictr_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/chictr/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('chictr_detail', res.data);
		}
	},
	// 美国临床试验-详情页数据
	async linchuangus_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/linchuangus/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('linchuangus_detail', res.data);
		}
	},
	// 韩国临床试验-详情页数据
	async linchuangkr_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/linchuangkr/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('linchuangkr_detail', res.data);
		}
	},
	// 日本临床试验-详情页数据
	async linchuangjp_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/linchuangjp/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('linchuangjp_detail', res.data);
		}
    },
    // 澳洲临床试验-详情页数据
    async linchuangau_detail({ commit }, oid) {
        let loading = common.loadingFullPage();
        let res = await request.post('/linchuangau/getInfo', {
            oid
        })
        loading.close();
        if (res.state == 0) {
            commit('linchuangau_detail', res.data);
        }
    },
	// 合同研究组织CRO-详情页数据
	async ksr88cro_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/htyjzz/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('ksr88cro_detail', res.data);
		}
	},
	// 第三方实验室LAB-详情页数据
	async ksr88lab_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/dsfsys/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('ksr88lab_detail', res.data);
		}
	},
	// 医学指南-详情页数据
	async medicalguide_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/medicalguide/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('medicalguide_detail', res.data);
		}
	},
	// 临床试验现场管理组织（SMO）-详情页数据
	async smo_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/smo/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('smo_detail', res.data);
		}
	},
	// 其他供应商-详情页数据
	async supplier_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/supplier/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('supplier_detail', res.data);
		}
	},
	// 指导原则 - 详情页数据
	async guideprinciple_detail({ commit }, oid) {
		let loading = common.loadingFullPage();
		let res = await request.post('/guideprinciple/getInfo', {
			oid
		})
		loading.close();
		if (res.state == 0) {
			commit('guideprinciple_detail', res.data);
		}
    },
    // 研究者风险信息 - 详情页数据
    async researcherrisk_detail({ commit }, oid) {
        let loading = common.loadingFullPage();
        let res = await request.post('/doctorrisk/getInfo', {
            oid
        })
        loading.close();
        if (res.state == 0) {
            commit('researcherrisk_detail', res.data);
        }
    },
    // 企业信息 - 详情页数据
    async firm_detail({ commit }, firmid) {
        let res = await request.post('/general/info', {
            id: firmid
        })
        if (res.state == 0) {
            commit('firm_detail', res.data);
        }
    },
}

export default {
	state,
	mutations,
	actions
}
